import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListPaymentSystem = (params) => {
    return axios.get(`${backendHost}/api/admin/payment/list`, {params});
};

export {
    getListPaymentSystem
}